module.exports = __webpack_public_path__ + "static/media/lock.2196d5ee.svg";